import getSeats from './getSeats';
import { isSeatOccupied } from './seats';

/**
 * Auto-selects the first N available seats from a bus layout.
 * Excludes hallway, petFriendly, and occupied seats.
 * Used by Quick Purchase to automatically assign seats to passengers.
 * @param {Array} busLayout - 2D array representing the bus seat layout.
 * @param {string} tripSlug - Trip identifier.
 * @param {number} passengerCount - Number of seats to select.
 * @returns {Array|null} Array of seat objects or null if not enough seats available.
 */
const autoSelectSeats = (busLayout, tripSlug, passengerCount) => {
  const seats = getSeats(busLayout, tripSlug);

  const availableSeats = Object.entries(seats)
    .filter(([key]) => key !== 'categories')
    .map(([, seat]) => seat)
    .filter((seat) => seat.category !== 'hallway' && !seat.petFriendly && !isSeatOccupied(seat))
    .sort((a, b) => a.index - b.index);

  if (availableSeats.length < passengerCount) {
    return null;
  }

  return availableSeats.slice(0, passengerCount);
};

export default autoSelectSeats;
